import React from 'react';

// 04-enforce.md 4.1 -- extraído de SubPanelTratos.jsx (rama `resolvedNodeSub === 'operacion-activa'`
// del tab "Parámetros"). Puramente presentacional: dashboard de estadísticas de una operación ya
// activa (avatar, tags de rango de tiempo, tarjetas de resumen, gráfica SVG). Los valores de la
// gráfica/tarjetas son data mock por rango (`activeTimeTag`) -- preservados tal cual, no es parte
// de esta extracción arreglarlos.
const SubPanelOperacionActiva = ({ op, activeTimeTag, onChangeTimeTag }) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-5)', padding: 'var(--space-1) 0' }}>

      {/* 1. User Profile Section */}
      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: 'var(--space-4)',
        background: 'rgba(255, 255, 255, 0.02)',
        border: '1px solid rgba(255, 255, 255, 0.06)',
        borderRadius: 'var(--radius-lg)',
        padding: 'var(--space-4)'
      }}>
        {/* Large Circular Avatar */}
        <div style={{
          width: '72px',
          height: '72px',
          borderRadius: '50%',
          overflow: 'hidden',
          border: '2px solid rgba(255, 255, 255, 0.1)',
          background: 'linear-gradient(135deg, #3b82f6 0%, #1e3a8a 100%)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0
        }}>
          {op.cliente_img ? (
            <img src={op.cliente_img} alt={op.cliente_nick} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
          ) : (
            <span style={{ fontSize: '28px', color: '#fff', fontWeight: 'bold' }}>
              {(op.cliente_nick || '?')[0].toUpperCase()}
            </span>
          )}
        </div>

        {/* Vertical Text Stack */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-1)' }}>
          <div style={{ fontSize: '16px', fontWeight: '600', color: '#fff' }}>
            {op.cliente_nick || 'Sin cliente'}
          </div>
          <div style={{ fontSize: '13px', color: 'rgba(255, 255, 255, 0.6)', display: 'flex', alignItems: 'center', gap: 'var(--space-2)' }}>
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>
            {op.cliente_correo || 'correo@ejemplo.com'}
          </div>
          <div style={{ fontSize: '13px', color: 'rgba(255, 255, 255, 0.6)', display: 'flex', alignItems: 'center', gap: 'var(--space-2)' }}>
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/></svg>
            {op.cliente_tel || op.telefono || '+52 55 1234 5678'}
          </div>
        </div>
      </div>

      {/* 2. Filter Tags Row */}
      <div style={{ display: 'flex', gap: 'var(--space-2)', flexWrap: 'wrap' }}>
        {['Todo', 'Hoy', 'Semana', 'Mes', 'Custom'].map(tag => {
          const isActive = activeTimeTag === tag;
          return (
            <button
              key={tag}
              type="button"
              onClick={() => onChangeTimeTag(tag)}
              style={{
                background: isActive ? 'rgba(59, 130, 246, 0.15)' : 'rgba(255, 255, 255, 0.03)',
                border: `1px solid ${isActive ? '#3b82f6' : 'rgba(255, 255, 255, 0.08)'}`,
                color: isActive ? '#3b82f6' : 'rgba(255, 255, 255, 0.6)',
                padding: 'var(--space-2) var(--space-3)',
                borderRadius: 'var(--radius-sm)',
                fontSize: '11px',
                fontWeight: '600',
                textTransform: 'uppercase',
                cursor: 'pointer',
                transition: 'all 0.2s',
                outline: 'none'
              }}
              onMouseEnter={e => {
                if (!isActive) {
                  e.currentTarget.style.background = 'rgba(255, 255, 255, 0.08)';
                  e.currentTarget.style.color = '#fff';
                }
              }}
              onMouseLeave={e => {
                if (!isActive) {
                  e.currentTarget.style.background = 'rgba(255, 255, 255, 0.03)';
                  e.currentTarget.style.color = 'rgba(255, 255, 255, 0.6)';
                }
              }}
            >
              {tag}
            </button>
          );
        })}
      </div>

      {/* 3. Resumen de Trato (Three Stat Boxes) */}
      <div style={{
        background: 'rgba(255, 255, 255, 0.02)',
        border: '1px solid rgba(255, 255, 255, 0.06)',
        borderRadius: 'var(--radius-lg)',
        padding: 'var(--space-4)',
        display: 'flex',
        flexDirection: 'column',
        gap: 'var(--space-3)'
      }}>
        <div style={{ fontSize: '11px', fontWeight: '700', color: 'rgba(255,255,255,0.4)', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
          Resumen de Trato
        </div>
        <div style={{ display: 'flex', gap: 'var(--space-3)' }}>
          {/* Monto total operado */}
          <div style={{
            flex: 1,
            background: 'rgba(255, 255, 255, 0.01)',
            border: '1px solid rgba(255, 255, 255, 0.04)',
            borderRadius: 'var(--radius-md)',
            padding: 'var(--space-3)',
            display: 'flex',
            flexDirection: 'column',
            gap: 'var(--space-1)'
          }}>
            <div style={{ fontSize: '10px', color: 'rgba(255, 255, 255, 0.4)', fontWeight: '500' }}>Monto total operado</div>
            <div style={{ fontSize: '16px', fontWeight: '700', color: '#fff' }}>
              {new Intl.NumberFormat('es-MX', { style: 'currency', currency: op.currency || 'MXN' }).format(parseFloat(op.amount) || 0)}
            </div>
          </div>

          {/* Costo de operacion */}
          <div style={{
            flex: 1,
            background: 'rgba(255, 255, 255, 0.01)',
            border: '1px solid rgba(255, 255, 255, 0.04)',
            borderRadius: 'var(--radius-md)',
            padding: 'var(--space-3)',
            display: 'flex',
            flexDirection: 'column',
            gap: 'var(--space-1)'
          }}>
            <div style={{ fontSize: '10px', color: 'rgba(255, 255, 255, 0.4)', fontWeight: '500' }}>Costo de operación</div>
            <div style={{ fontSize: '16px', fontWeight: '700', color: '#fff' }}>
              {new Intl.NumberFormat('es-MX', { style: 'currency', currency: op.currency || 'MXN' }).format(parseFloat(op.cost) || 0)}
            </div>
          </div>

          {/* Utilidad de operacion */}
          <div style={{
            flex: 1,
            background: 'rgba(255, 255, 255, 0.01)',
            border: '1px solid rgba(255, 255, 255, 0.04)',
            borderRadius: 'var(--radius-md)',
            padding: 'var(--space-3)',
            display: 'flex',
            flexDirection: 'column',
            gap: 'var(--space-1)'
          }}>
            <div style={{ fontSize: '10px', color: 'rgba(255, 255, 255, 0.4)', fontWeight: '500' }}>Utilidad de operación</div>
            <div style={{ fontSize: '16px', fontWeight: '700', color: '#fff' }}>
              {new Intl.NumberFormat('es-MX', { style: 'currency', currency: op.currency || 'MXN' }).format(parseFloat(op.price_amount) || parseFloat(op.price) || 0) - (parseFloat(op.cost) || 0)}
            </div>
          </div>
        </div>
      </div>

      {/* 4. Statistics Header */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 'var(--space-1)' }}>
        <div style={{ fontSize: '14px', fontWeight: '600', color: '#fff' }}>
          Estadísticas de Operación
        </div>
        <div style={{
          background: 'rgba(59, 130, 246, 0.15)',
          border: '1px solid rgba(59, 130, 246, 0.3)',
          color: '#3b82f6',
          fontSize: '10px',
          fontWeight: '700',
          padding: '2px var(--space-2)',
          borderRadius: 'var(--radius-lg)',
          textTransform: 'uppercase'
        }}>
          {activeTimeTag}
        </div>
      </div>

      {/* 5. Compras & Ticket Promedio Detailed Cards */}
      <div style={{ display: 'flex', gap: 'var(--space-3)' }}>
        {/* Compras Card */}
        <div style={{
          flex: 1,
          background: 'rgba(255, 255, 255, 0.02)',
          border: '1px solid rgba(255, 255, 255, 0.06)',
          borderRadius: 'var(--radius-lg)',
          padding: 'var(--space-3)',
          display: 'flex',
          flexDirection: 'column',
          gap: 'var(--space-2)'
        }}>
          <div style={{ fontSize: '11px', color: 'rgba(255, 255, 255, 0.4)', fontWeight: '500' }}>Compras</div>
          <div style={{ display: 'flex', alignItems: 'baseline', gap: 'var(--space-2)' }}>
            <span style={{ fontSize: '20px', fontWeight: '700', color: '#fff' }}>
              {activeTimeTag === 'Hoy' ? '8' : activeTimeTag === 'Semana' ? '34' : activeTimeTag === 'Mes' ? '148' : activeTimeTag === 'Todo' ? '1,842' : '94'}
            </span>
            <span style={{
              fontSize: '11px',
              fontWeight: '600',
              color: activeTimeTag === 'Custom' ? '#ef4444' : '#10b981',
              display: 'flex',
              alignItems: 'center'
            }}>
              {activeTimeTag === 'Custom' ? '↓ 3.2%' : '↑ 12.4%'}
            </span>
          </div>
        </div>

        {/* Ticket Promedio Card */}
        <div style={{
          flex: 1,
          background: 'rgba(255, 255, 255, 0.02)',
          border: '1px solid rgba(255, 255, 255, 0.06)',
          borderRadius: 'var(--radius-lg)',
          padding: 'var(--space-3)',
          display: 'flex',
          flexDirection: 'column',
          gap: 'var(--space-2)'
        }}>
          <div style={{ fontSize: '11px', color: 'rgba(255, 255, 255, 0.4)', fontWeight: '500' }}>Ticket Promedio</div>
          <div style={{ display: 'flex', alignItems: 'baseline', gap: 'var(--space-2)' }}>
            <span style={{ fontSize: '18px', fontWeight: '700', color: '#fff' }}>
              {new Intl.NumberFormat('es-MX', { style: 'currency', currency: op.currency || 'MXN', maximumFractionDigits: 0 }).format(parseFloat(op.ticket_promedio) || 2450)}
            </span>
            <span style={{
              fontSize: '11px',
              fontWeight: '600',
              color: '#10b981',
              display: 'flex',
              alignItems: 'center'
            }}>
              ↑ 8.2%
            </span>
          </div>
        </div>
      </div>

      {/* 6. Dynamic Responsive SVG Chart */}
      <div style={{
        background: 'rgba(255, 255, 255, 0.02)',
        border: '1px solid rgba(255, 255, 255, 0.06)',
        borderRadius: 'var(--radius-lg)',
        padding: 'var(--space-4)',
        display: 'flex',
        flexDirection: 'column',
        gap: 'var(--space-3)'
      }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '11px', color: 'rgba(255, 255, 255, 0.4)' }}>
          <span>Aumento de operaciones</span>
          <span>{activeTimeTag === 'Hoy' ? '30 días para atrás' : activeTimeTag === 'Semana' ? '4 semanas para atrás' : activeTimeTag === 'Mes' ? '3 meses para atrás' : activeTimeTag === 'Todo' ? '3 años para atrás' : 'Período personalizado'}</span>
        </div>

        {/* SVG Chart */}
        <div style={{ width: '100%', height: '120px', position: 'relative' }}>
          <svg viewBox="0 0 300 100" width="100%" height="100%" preserveAspectRatio="none" style={{ overflow: 'visible' }}>
            <defs>
              <linearGradient id="chartGradient" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#3b82f6" stopOpacity="0.4" />
                <stop offset="100%" stopColor="#3b82f6" stopOpacity="0.0" />
              </linearGradient>
            </defs>

            {/* SVG Grid Lines */}
            <line x1="0" y1="25" x2="300" y2="25" stroke="rgba(255, 255, 255, 0.03)" strokeWidth="0.5" />
            <line x1="0" y1="50" x2="300" y2="50" stroke="rgba(255, 255, 255, 0.03)" strokeWidth="0.5" />
            <line x1="0" y1="75" x2="300" y2="75" stroke="rgba(255, 255, 255, 0.03)" strokeWidth="0.5" />

            {/* Area Path */}
            <path
              d={
                activeTimeTag === 'Hoy'
                  ? "M 0 80 Q 25 70 50 60 T 100 80 T 150 40 T 200 50 T 250 20 T 300 10 L 300 100 L 0 100 Z"
                  : activeTimeTag === 'Semana'
                  ? "M 0 90 Q 50 70 100 65 T 200 30 T 300 20 L 300 100 L 0 100 Z"
                  : activeTimeTag === 'Mes'
                  ? "M 0 75 Q 50 85 100 50 T 200 45 T 300 15 L 300 100 L 0 100 Z"
                  : activeTimeTag === 'Todo'
                  ? "M 0 95 Q 50 90 100 80 T 200 40 T 300 10 L 300 100 L 0 100 Z"
                  : "M 0 85 Q 50 75 100 70 T 200 65 T 300 60 L 300 100 L 0 100 Z"
              }
              fill="url(#chartGradient)"
            />

            {/* Stroke Line */}
            <path
              d={
                activeTimeTag === 'Hoy'
                  ? "M 0 80 Q 25 70 50 60 T 100 80 T 150 40 T 200 50 T 250 20 T 300 10"
                  : activeTimeTag === 'Semana'
                  ? "M 0 90 Q 50 70 100 65 T 200 30 T 300 20"
                  : activeTimeTag === 'Mes'
                  ? "M 0 75 Q 50 85 100 50 T 200 45 T 300 15"
                  : activeTimeTag === 'Todo'
                  ? "M 0 95 Q 50 90 100 80 T 200 40 T 300 10"
                  : "M 0 85 Q 50 75 100 70 T 200 65 T 300 60"
              }
              fill="none"
              stroke="#3b82f6"
              strokeWidth="2.5"
              strokeLinecap="round"
            />

            {/* Dots on peak points */}
            <circle cx="300" cy={activeTimeTag === 'Hoy' ? "10" : activeTimeTag === 'Semana' ? "20" : activeTimeTag === 'Mes' ? "15" : activeTimeTag === 'Todo' ? "10" : "60"} r="4" fill="#3b82f6" stroke="#fff" strokeWidth="1" />
          </svg>
        </div>

        {/* X Axis Labels */}
        <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '10px', color: 'rgba(255, 255, 255, 0.3)', marginTop: '-4px' }}>
          {activeTimeTag === 'Hoy' ? (
            <>
              <span>30 días atrás</span>
              <span>15 días atrás</span>
              <span>Hoy</span>
            </>
          ) : activeTimeTag === 'Semana' ? (
            <>
              <span>Hace 4 sem</span>
              <span>Hace 3 sem</span>
              <span>Hace 2 sem</span>
              <span>Sem actual</span>
            </>
          ) : activeTimeTag === 'Mes' ? (
            <>
              <span>Hace 3 meses</span>
              <span>Hace 2 meses</span>
              <span>Mes actual</span>
            </>
          ) : activeTimeTag === 'Todo' ? (
            <>
              <span>2024</span>
              <span>2025</span>
              <span>2026</span>
            </>
          ) : (
            <>
              <span>Inicio</span>
              <span>Medio</span>
              <span>Fin</span>
            </>
          )}
        </div>
      </div>

    </div>
  );
};

export default SubPanelOperacionActiva;
